import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Link from '~/components/Link/Link';

const Container = styled.div`
  height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default class Error extends React.Component {
  static getInitialProps({ res, err }) {
    const errorCode = err ? err.statusCode : null;
    const statusCode = res ? res.statusCode : errorCode;
    return { statusCode };
  }

  static propTypes = {
    statusCode: PropTypes.number,
  };

  refreshPage = () => {
    window.location.reload();
  };

  render() {
    const { statusCode } = this.props;
    return (
      <Container>
        {statusCode === 404 && (
          <p>Page not found, click <Link to="/">HERE</Link> to go to home page</p>
        )}
        {statusCode && statusCode !== 404 && (
          <p>An error occurred on server, please refresh or click <a onClick={this.refreshPage}>HERE</a> to resolve the problem</p>
        )}
      </Container>
    );
  }
}
